module.exports = __webpack_public_path__ + "images/manifestum/laruche.c9104308.jpg";